import React, { useEffect, useState } from 'react'
// import styles from "./styles.module.scss";
import { Report } from 'notiflix/build/notiflix-report-aio'
import { Loading } from 'notiflix'
import { titleData } from '../../../data/titles'
import { contactPreferencesData } from '../../../data/contactPreferences'
import {
    InputFieldText,
    InputFieldSelect,
    FieldGroup,
    Field,
    SubmitButton,
    ButtonContainer,
    FieldContainer,
    FormCard,
} from '../../reusable'

import { FormPartInterface, SaveValueInterface } from '../../../interfaces'
import { Checkbox } from '../../reusable/checkbox'
import { InputFieldAddressLookup } from '../../reusable/inputFieldAddressLookup'
import { sectionValidation } from '../../../helpers'
import { useClaimData, useUpdateClaimData } from '../../../claimProvider'
import globalStyles from '../../../globals/pages.module.scss'

interface StepData {
    telephone?: string
    email?: string
    [key: string]: string | undefined
}

export const ContactDetails = (props: FormPartInterface) => {
    const { saveValueFunct, isActive, assignGroup } = props
    const [currentStep, setCurrentStep] = React.useState(0)
    const [postCurrentStep, setPostCurrentStep] = React.useState(0)
    const [stepData, setStepData] = useState<StepData>({})
    const [formErrors, setFormErrors] = useState<{ [key: string]: boolean }>({})
    const [showErrors, setShowErrors] = useState(false)

    const claimData = useClaimData()
    const updateClaim = useUpdateClaimData()

    useEffect(() => {
        if (claimData.telephone || claimData.email) {
            setStepData({
                telephone: claimData.telephone || '',
                email: claimData.email || '',
            })
        }
    }, [claimData])

    const preSaveValueFunct = (dataToSave: SaveValueInterface) => {
        const saved = saveValueFunct(dataToSave)
        if (saved.success) {
            setStepData((prevData: StepData) => ({
                ...prevData,
                [dataToSave.field]: dataToSave.value,
            }))
            // Clear error for this field if it has a value
            if (dataToSave.value.trim()) {
                setFormErrors((prev) => ({
                    ...prev,
                    [dataToSave.field]: false,
                }))
            }
        }
        return saved
    }

    const validateForm = () => {
        const newErrors: { [key: string]: boolean } = {}
        let hasErrors = false

        // Check required fields
        if (!stepData.telephone?.trim()) {
            newErrors.telephone = true
            hasErrors = true
        }
        if (!stepData.email?.trim()) {
            newErrors.email = true
            hasErrors = true
        }

        setFormErrors(newErrors)
        return !hasErrors
    }

    const handleNext = () => {
        setShowErrors(true)
        if (!validateForm()) {
            return
        }

        Loading.standard('Saving your details...')

        // Save all fields to global state while preserving client_id and setting type
        const updatedData = {
            ...claimData,
            ...stepData,
            type: 'webform_SENTINEL_ALTERNATE',
            client_id: claimData.client_id,
        }
        updateClaim(updatedData)

        Loading.remove()
        setTimeout(() => {
            assignGroup('confirm')
        }, 400)
    }

    const getCurrentStep = () => {
        return isActive === 'contact' ? (
            <FieldGroup title="Contact Information">
                <FormCard assignPostStep={setPostCurrentStep} step={currentStep} onBack={() => assignGroup('person')}>
                    <h3>Your Contact Details</h3>
                    <p className={`${globalStyles.contactDetailsText}`}>
                        Please enter your telephone number and e-mail address so we can contact you regarding your
                        claims.
                    </p>
                    <Field extraStyle={{ padding: '0' }} fieldLabel="Telephone" labelPosition="left" enhanced={true}>
                        <InputFieldText
                            fieldName="telephone"
                            saveValue={preSaveValueFunct}
                            fieldType={'tel'}
                            populateValue={stepData.telephone || ''}
                            enhanced={true}
                            required={true}
                            showErrors={showErrors}
                        />
                    </Field>
                    <Field extraStyle={{ padding: '0' }} fieldLabel="Email" labelPosition="left" enhanced={true}>
                        <InputFieldText
                            fieldName="email"
                            saveValue={preSaveValueFunct}
                            fieldType={'email'}
                            populateValue={stepData.email || ''}
                            enhanced={true}
                            required={true}
                            showErrors={showErrors}
                        />
                    </Field>
                    {/* <Field extraStyle={{ padding: '0' }} fieldLabel="Search Address" labelPosition="left">
                        <InputFieldAddressLookup fieldName={`searchAddress`} saveValue={preSaveValueFunct} />
                    </Field>
                    {AddressText.length > 0 && (
                        <>
                            <Field extraStyle={{ padding: '0' }} fieldLabel="Address Line 1" labelPosition="left">
                                <InputFieldText
                                    fieldName="address_line_one"
                                    saveValue={preSaveValueFunct}
                                    populateValue={AddressOne}
                                />
                            </Field>
                            <Field extraStyle={{ padding: '0' }} fieldLabel="Address Line 2" labelPosition="left">
                                <InputFieldText
                                    fieldName="address_line_two"
                                    saveValue={preSaveValueFunct}
                                    populateValue={AddressTwo}
                                />
                            </Field>
                            <Field extraStyle={{ padding: '0' }} fieldLabel="Address Line 3" labelPosition="left">
                                <InputFieldText
                                    fieldName="addres_line_three"
                                    saveValue={preSaveValueFunct}
                                    populateValue={AddressThree}
                                />
                            </Field>
                            <Field extraStyle={{ padding: '0' }} fieldLabel="City" labelPosition="left">
                                <InputFieldText
                                    fieldName="city"
                                    saveValue={preSaveValueFunct}
                                    populateValue={AddressCity}
                                />
                            </Field>
                            <Field extraStyle={{ padding: '0' }} fieldLabel="Postcode" labelPosition="left">
                                <InputFieldText
                                    fieldName="postcode"
                                    saveValue={preSaveValueFunct}
                                    populateValue={AddressPostcode}
                                />
                            </Field>
                        </>
                    )} */}
                    {/* <p>
                        By clicking the button below, you confirm you give your permission for Sentinel Legal Ltd to
                        contact you by telephone, e-mail or post regarding your claim.
                    </p> */}
                    <SubmitButton text="Review Details" btnType="primary" onClick={handleNext} />
                </FormCard>
            </FieldGroup>
        ) : (
            <></>
        )
    }

    return getCurrentStep()
}
